import React, { useState } from 'react';
import AdminLogin from './AdminLogin';

const AdminRoute = ({ children }) => {
  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(
    () => sessionStorage.getItem('admin_authenticated') === 'true'
  );

  if (!isAdminAuthenticated) {
    return <AdminLogin onLogin={setIsAdminAuthenticated} />;
  }

  return children;
};

export default AdminRoute;
